// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { useEffect, useState, forwardRef } from 'react';
import { TextAreaRef } from 'antd/es/input/TextArea';
import { TextAreaProps } from 'antd/es/input';
import { useTranslation } from 'react-i18next';
import ReactQuill from 'react-quill-new';
import { StyledLabel, StyledTextAreaWrap } from './TextEditor.styles';
import Switch from '../Switch/Switch';
import HTMLEditor from '../HTMLEditor/HTMLEditor';
import { useBoolean } from '@/hooks';
import { TextEditor } from './TextEditor';

export interface ITextAreaProps extends Omit<TextAreaProps, 'onChange'> {
  onChange?: (v: string) => void;
  value?: string;
}
export interface ITextAreaQuillProps extends ReactQuill.ReactQuillProps {
  onChange?: (v: string) => void;
  value?: string;
  disabled: boolean;
}

export type TextEditorWithHtmlProps = (ITextAreaProps | ITextAreaQuillProps) & React.RefAttributes<TextAreaRef>;

const TextEditorWithHtml = forwardRef<TextAreaRef, TextEditorWithHtmlProps>(
  ({ value, disabled, onChange, ...props }, ref): JSX.Element => {
    const { t } = useTranslation(['common']);
    const { value: isHTMLMode, toggle: toggleHTMLMode } = useBoolean();
    const [description, setDescription] = useState<string>('');

    useEffect(() => {
      setDescription(value ?? props?.defaultValue);
    }, [value, props]);

    const onTextChange = (html: string, text: string = '') => {
      setDescription(html);

      const isFilledHtml = text?.trim().length || html.includes('img');
      return onChange && onChange(isFilledHtml ? html : '');
    };

    return (
      <StyledTextAreaWrap>
        <StyledLabel>
          {t('switch_to_HTML')}
          <Switch onChange={toggleHTMLMode} />
        </StyledLabel>
        {isHTMLMode ? (
          <HTMLEditor onChange={onTextChange} value={description ?? ''} {...props} disabled={disabled} ref={ref} />
        ) : (
          <TextEditor {...props} value={description} onChange={onTextChange} ref={ref} />
        )}
      </StyledTextAreaWrap>
    );
  },
);

TextEditorWithHtml.displayName = 'TextEditorWithHtml';

export default TextEditorWithHtml;
